/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { Button, Dropdown, Popup, Icon } from "semantic-ui-react";
import Axios from "axios";
import ReadMasterAxios from "../axiosComponent/readMaster";

import APP_CONSTANTS from "../../config/constants";
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";
import BillingPartyOnFly from "../../../src/views/masters/billingParty/branchEditOnFly";

const BillingPartyBranch = ({
  field: { name },
  form: { setFieldValue },
  getBillingBranchSelected,
  //billingBranchState,
  ...props
}) => {
  const [billingPartyBranch, setBillingPartyBranch] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshlist, setrefreshlist] = useState(false);

  useEffect(() => {
    console.log(props.id);
    console.log("BranchOnTheFly",props);
    setIsLoading(true);
    getbillingparty();
    setIsLoading(false);
  }, [props.id, refreshlist]);

  const getbillingparty = () => {
    let btemparray = localStorage.getItem("billingpartbranchIds");
    if ((props.id != "null" || props.id != "undefined") && props.id) {
      allAxiosCommonRequest({
        url: "masters/billing_party_branch",
        method: "get",
        getValues: `billingPartyId=${props.id}&`,
      })
        .then((response) => {
          let options = response.data.resultSet;
          if (btemparray != "") {
            let btemp = btemparray.split(",");
            let btempa = [];
            for (let index = 0; index < options.length; index++) {
              for (let indexj = 0; indexj < btemp.length; indexj++) {
                if (options[index].billingPartyBranchId == +btemp[indexj]) {
                  btempa.push(options[index]);
                }
              }
            }
            let temp = btempa.map((item, index) => {
              return {
                key: item.billingPartyBranchId,
                value: item.billingPartyBranchId,
                text: item.billingPartyBranchName,
                raw: { ...item },
              };
            });
            setBillingPartyBranch(temp);
          } else {
            let temp = options.map((item, index) => {
              return {
                key: item.billingPartyBranchId,
                value: item.billingPartyBranchId,
                text: item.billingPartyBranchName,
                raw: { ...item },
              };
            });
            setBillingPartyBranch(temp);
          }
        })
        .catch((error) => console.log(error));
    } else {
      setBillingPartyBranch([]);
    }
  };

  let options = [];
  if (billingPartyBranch && billingPartyBranch.length > 0) {
    billingPartyBranch.map((object, index) => {
      let temp = {};
      temp.key = object.key;
      temp.text = object.text;
      temp.value = object.value;
      return (options[index] = temp);
    });
  }

  const handleOnChange = (e, data) => {
    if (data.value) setFieldValue(name, data.value);
    else setFieldValue(name, null);
    if (props?.placeholderName) {
      let selected = data.options.filter((object, index) => {
        if (object.value == data.value) {
          return object.text;
        }
      });
      setFieldValue(props.placeholderName, selected[0]?.text);
    }

    
  };

const [branchmodal, setbranchmodal] = useState(false);

const BranchModalClose = () => {
  setbranchmodal(false);
};

const BranchModalOpen = () => {
  setbranchmodal(true);
};

const Reloadthelist = () => {
  setrefreshlist(!refreshlist);
  setFieldValue(name, "");
  setFieldValue(props.placeholderName, "");
};

  return (
    <>
      <div className="display-flex-center width-100cent">
        <div className="billing-party_dropdown">
          <Dropdown
            selection
            clearable
            search
            onChange={handleOnChange}
            placeholder={props.placeholder}
            options={options}
            loading={isLoading}
            {...props}
            fluid
          />
        </div>
          <BillingPartyOnFly
            billingPartyID={props.billingPartyID}
            branchModal={branchmodal}
            CloseModal={BranchModalClose}
            OpenModal={BranchModalOpen}
            productName={"Billing Party Branch"}
            vendor_code={props.vendor_code}
            {...props}
            onFormSubmit={Reloadthelist}
          />
        
      </div>
    </>
  );
};

export default BillingPartyBranch;
